
import { useState, useEffect } from 'react';
import { CycleData, generateCycleData } from '@/utils/cycle-tracking';
import { subDays } from 'date-fns';

export const useCycleData = (updateSymptomCycleData?: (data: CycleData) => void) => {
  const [cycleData, setCycleData] = useState<CycleData | null>(null);
  
  useEffect(() => {
    // Generate cycle data or fetch from API
    const lastPeriod = subDays(new Date(), 10); // Example: period started 10 days ago
    const generatedCycleData = generateCycleData(lastPeriod);
    setCycleData(generatedCycleData);
    
    if (updateSymptomCycleData && generatedCycleData) {
      updateSymptomCycleData(generatedCycleData);
    }
  }, [updateSymptomCycleData]);
  
  return { cycleData };
};
